import { observer } from 'mobx-react-lite';
import StyleEffectsPanel from './StyleEffectsPanel';
import type { StyleEffectsPanelProps, StyleEffectsPanelValueProps } from './types';

export type { StyleEffectsPanelProps, StyleEffectsPanelValueProps };
export default observer(StyleEffectsPanel); // MANUAL OVERRIDE
